module.exports = __webpack_public_path__ + "img/flux-capacitor.810a560e.svg";